import { CommunityComment } from '@/types'
import { useCallback, useMemo, useState } from 'react'
import { useCommunityReplies } from './comments'

const step = 5
const initialShowLimit = 3

export const useCommentReplies = (comment: CommunityComment) => {
  const query = useCommunityReplies(comment?.id, comment?.replies)
  const commentReplies = query.data

  const [limit, setLimite] = useState(initialShowLimit)

  const { replies, showViewMore, showHideAll, commentsCount } = useMemo(() => {
    const commentsCount = commentReplies?.length

    const cannotShow = query.isLoading || query.isFetching || commentsCount <= initialShowLimit || !commentsCount

    return {
      replies: commentReplies.slice(0, limit),
      showViewMore: cannotShow ? false : limit < commentsCount,
      showHideAll: cannotShow ? false : limit >= commentsCount,
      commentsCount: Math.min(commentsCount - limit, step)
    }
  }, [limit, commentReplies, query.isLoading, query.isFetching])

  const handleViewMore = useCallback(() => {
    setLimite(currentLimit => currentLimit + step)
  }, [])

  const handleHideAll = useCallback(() => {
    setLimite(initialShowLimit)
  }, [])

  const hasReplies = !!replies?.length && replies?.length > 0

  return {
    replies,
    showViewMore,
    showHideAll,
    commentsCount,
    handleViewMore,
    handleHideAll,
    query,
    limit,
    hasViewedMore: limit > initialShowLimit,
    hasReplies
  }
}
